import { useState, useCallback } from "react";
import { Form, Collapse } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./Agent.css";
import TopHeader from "../Common/TopHeader";
import { PostApiMethod, PutApiMethod } from "../../core/services/apiService";
import constant from "../../core/constant";
import { restrictIntialSpace, ActivateDeactivate, Checkeligibility, DisplayToaster, DisplayErrorMessages } from "../../core/services/sharedService";
import AppModal from "../AppModal/AppModal";
import SearchableSelect from "../Common/SearchableSelect";

const CreateAgent = () => {
    let navigate = useNavigate();

    const locations = useLocation();

    const getAllLocationIds = locations?.state?.agentMappedLocationDetails?.map(({ id }: { id: string }) => (
        id
    ));

    Checkeligibility(constant.AGENT_EDIT, locations, constant.AGENT_LIST);

    const { register, handleSubmit, control, formState: { errors } } = useForm<any>();

    const [disable, setDisable] = useState(false);
    const [isLoading, setLoading] = useState<boolean>(false);
    const [showPopUp, setShowPopUp] = useState(false);
    // const [assignAllLocs, setAssignAllLocs] = useState<boolean>(locations.state.assignAllLocs);
    const [checkedLocs, setCheckedLocs] = useState<string[]>(locations?.state?.assignAllLocs ? getAllLocationIds : locations?.state?.mappedLocations);
    const [hiddenLocs, setHiddenLocs] = useState<string[]>(locations?.state?.hiddenLocations || []);
    const [isLocationsExpanded, setIsLocationsExpanded] = useState<boolean>(true);
    const [locationSearchQuery, setLocationSearchQuery] = useState<string>("");

    const agenturl = "tenant/agent-crud";
    const buttonname: string = locations.state !== null ? "Update" : "Submit";
    const headername: string =
        locations.state !== null
            ? "Edit Agent - " + locations.state?.names
            : "Create Agent";

    const pageDisable = () => {
        setDisable(true);
        setLoading(true);
        document.body.classList.add('screen-disable');
    }

    const pageEnable = () => {
        setDisable(false);
        setLoading(false);
        document.body.classList.remove('screen-disable');
    }

    const handleRegistration = (data: {
        name: string,
        email: string,
        display_name: string,
        timeZone: string,
        assignAllLocs: boolean,
        mappedLocations: string[]
    }) => {
        let postDate = {
            name: data.name?.trim(),
            email: data.email?.trim(),
            display_name: data.display_name?.trim(),
            timeZone: data.timeZone,
            assignAllLocs: getAllLocationIds?.length === checkedLocs?.length,
            mappedLocations: (getAllLocationIds?.length === checkedLocs?.length) ? [] : checkedLocs,
            hiddenLocations: hiddenLocs
        };
        pageDisable();
        (locations.pathname === "/agent/create" ? PostApiMethod(agenturl, postDate) : PutApiMethod(`${agenturl}/${locations.state.id}`, postDate))
            .then((res) => {
                if (res.data.status === "Success") {
                    pageEnable();
                    navigate(constant.AGENT_LIST);
                    DisplayToaster("bg-success", "Agent " + data.name + " details " + (locations.pathname === "/agent/create" ? "created" : "updated") + " successfully");
                }
            })
            .catch((err) => {
                pageEnable();
                DisplayToaster("bg-danger", DisplayErrorMessages(err) ? DisplayErrorMessages(err) : "Something went wrong!");
            });
    };

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.checked === true) {
            setCheckedLocs((prev) => { return [...prev, event.target.name] });
        } else {
            setCheckedLocs((prev) => (prev.filter((item: string) => {
                return item !== event.target.name
            })));
        }
    }

    const handleHideChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.checked === true) {
            setHiddenLocs((prev) => { return [...prev, event.target.name] });
        } else {
            setHiddenLocs((prev) => (prev.filter((item: string) => {
                return item !== event.target.name
            })));
        }
    }
    return (
        <>

            {
                showPopUp &&
                (
                    <AppModal
                        title={`Confirm To ${locations.state.is_active ? "Deactivate" : "Activate"}!`}
                        bodyText={
                            `Are you sure to ${locations.state.is_active ? "deactivate" : "activate"} this Agent ?`
                        }
                        primaryButtonLabel={"Yes"}
                        secondaryButtonLabel={"No"}
                        primaryButtonEventEmitter={() => { ActivateDeactivate("Agent", locations.state?.names, "tenant/agent-crud", locations.state.id, locations.state.is_active, () => { navigate(constant.AGENT_LIST) }); setShowPopUp(false) }
                        }
                        secondaryButtonEventEmitter={() => setShowPopUp(false)}
                    />
                )
            }

            <div className="conatiner-fluid m-3">
                <TopHeader
                    disable={disable}
                    heading={headername}
                    to={constant.AGENT_LIST}
                    action="List"
                    className="bi bi-list-ul"
                    id="agent-list"
                />

                <Form onSubmit={handleSubmit(handleRegistration)}>
                    <div className="row mb-2">
                        <div className="col-md-4">
                            <label>
                                Name <span className="text-danger">*</span>
                            </label>
                        </div>
                        <div className="col-md-4">
                            <input
                                type="text"
                                defaultValue={locations.state?.names}
                                className="form-control"
                                {...register('name', {
                                    required: true, minLength: 4, maxLength: 40,
                                    // onChange: (e) => { agentNameCheck(e, 'name') },
                                    pattern: {
                                        value: /^[a-zA-Z-0-9-_ ]*$/,
                                        message: 'Name field should contain only alphabets and numbers',
                                    },
                                })}
                                onKeyDown={(e) => { restrictIntialSpace(e) }}
                            />
                            {errors.name && errors.name.type === "required" && <small className='text-danger' >Name is required</small>}
                            {errors.name && errors.name.type === "minLength" && <small className='text-danger' >Minimum length should be 4 characters</small>}
                            {errors.name && errors.name.type === "maxLength" && <small className='text-danger' >Maximum length should not exceed 40 characters</small>}
                            {errors.name && errors.name.type === "pattern" && <small className='text-danger' >Name should contain only alphabets and numbers</small>}
                        </div>
                    </div>
                    <div className="row mb-2">
                        <div className="col-md-4">
                            <label>
                                Email <span className="text-danger">*</span>
                            </label>
                        </div>
                        <div className="col-md-4">
                            <input
                                type="text"
                                defaultValue={locations.state?.emails.trim()}
                                className="form-control"
                                onKeyDown={(e) => { restrictIntialSpace(e) }}
                                {...register('email',
                                    {
                                        required: true,
                                        pattern: {
                                            value: /^\w+([\+\.-]?\w+)*@\w+([\+\.-]?\w+)*(\.\w{2,3})+$/,
                                            message: 'Please enter a valid email',
                                        },
                                        setValueAs: (v) => v.trim()
                                    }
                                )}
                            />
                            {errors.email && errors.email.type === "required" && <small className='text-danger' >Email is required</small>}
                            {errors.email && errors.email.type === "pattern" && <small className='text-danger' >Please enter a valid email</small>}
                        </div>
                    </div>
                    <div className="row mb-2">
                        <div className="col-md-4">
                            <label>
                                Display Name <span className="text-danger">*</span>
                            </label>
                        </div>
                        <div className="col-md-4">
                            <input
                                type="text"
                                defaultValue={locations.state?.display_names}
                                className="form-control"
                                onKeyDown={(e) => { restrictIntialSpace(e) }}
                                {...register('display_name', {
                                    required: true, minLength: 4, maxLength: 40, pattern: {
                                        value: /^[a-zA-Z-0-9-_ ]*$/,
                                        message: 'Display Name field should contain only alphabets and numbers',
                                    },
                                })}
                            />
                            {errors.display_name && errors.display_name.type === "required" && <small className='text-danger' >Display Name is required</small>}
                            {errors.display_name && errors.display_name.type === "minLength" && <small className='text-danger' >Minimum length should be 4 characters</small>}
                            {errors.display_name && errors.display_name.type === "maxLength" && <small className='text-danger' >Maximum length should not exceed 40 characters</small>}
                            {errors.display_name && errors.display_name.type === "pattern" && <small className='text-danger' >Display Name should contain only alphabets and numbers</small>}
                        </div>
                    </div>
                    <div className="row mb-2">
                        <div className="col-md-4">
                            <label>
                                Time Zone <span className="text-danger">*</span>
                            </label>
                        </div>
                        <div className="col-md-4">
                            <Controller
                                name="timeZone"
                                control={control}
                                defaultValue={locations.state?.timeZone || ""}
                                rules={{ required: true }}
                                render={({ field }) => (
                                    <SearchableSelect
                                        options={constant.timeZones}
                                        value={field.value}
                                        onChange={field.onChange}
                                        placeholder="Search timezone..."
                                    />
                                )}
                            />
                            {errors?.timeZone?.type === "required" && <small className='text-danger'>Time zone is required</small>}
                        </div>
                    </div>
                    {
                        locations?.state ?
                            <div className="row mb-2">
                                <div className="col-md-4">
                                    <label>
                                        Status
                                    </label>
                                </div>
                                <div className="col-md-4">
                                    <input
                                        type="text"
                                        value={locations.state.is_active ? "Active" : "Inactive"}
                                        disabled
                                        className="form-control"
                                    />
                                </div>
                            </div> : ""
                    }

                    {
                        (locations?.state) ?
                            <div className="row mb-2 mt-3">
                                <div className="col-md-4">
                                    <label><b>Locations</b></label>
                                </div>

                                <div className="col-md-4">
                                    {/* Collapsible Header */}
                                    <div
                                        className="d-flex align-items-center justify-content-center p-2 bg-light border rounded cursor-pointer position-relative"
                                        onClick={() => setIsLocationsExpanded(!isLocationsExpanded)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <span className="text-primary">
                                            Configure Locations
                                        </span>
                                        <i className={`bi bi-chevron-${isLocationsExpanded ? 'up' : 'down'} text-primary position-absolute`} style={{ right: '10px' }}></i>
                                    </div>

                                    {/* Collapsible Content */}
                                    {isLocationsExpanded && (
                                        <div className="border border-top-0 rounded-bottom p-3">
                                            <small className="d-block mb-3" style={{ color: '#d6327f' }}><b>Assign locations for this Agent to receive and make calls, or hide locations from the Agent's view</b></small>

                                            <div className="mb-3 position-relative mx-auto">
                                                <i className="bi bi-search position-absolute" style={{
                                                    left: '12px',
                                                    top: '50%',
                                                    transform: 'translateY(-50%)',
                                                    color: '#94a3b8',
                                                    fontSize: '0.9rem',
                                                    pointerEvents: 'none',
                                                    transition: 'color 0.2s ease'
                                                }}></i>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Search locations..."
                                                    value={locationSearchQuery}
                                                    onChange={(e) => setLocationSearchQuery(e.target.value)}
                                                    style={{
                                                        paddingLeft: '38px',
                                                        paddingRight: '16px',
                                                        paddingTop: '8px',
                                                        paddingBottom: '8px',
                                                        fontSize: '0.875rem',
                                                        height: '38px',
                                                        border: '1.5px solid #e2e8f0',
                                                        borderRadius: '8px',
                                                        backgroundColor: '#ffffff',
                                                        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)',
                                                        transition: 'all 0.2s ease',
                                                        outline: 'none'
                                                    }}
                                                    onFocus={(e: React.FocusEvent<HTMLInputElement>) => {
                                                        e.currentTarget.style.borderColor = '#3b82f6';
                                                        e.currentTarget.style.boxShadow = '0 0 0 3px rgba(59, 130, 246, 0.1), 0 1px 3px rgba(0, 0, 0, 0.05)';
                                                        const icon = e.currentTarget.previousElementSibling as HTMLElement;
                                                        if (icon) icon.style.color = '#3b82f6';
                                                    }}
                                                    onBlur={(e: React.FocusEvent<HTMLInputElement>) => {
                                                        e.currentTarget.style.borderColor = '#e2e8f0';
                                                        e.currentTarget.style.boxShadow = '0 1px 3px rgba(0, 0, 0, 0.05)';
                                                        const icon = e.currentTarget.previousElementSibling as HTMLElement;
                                                        if (icon) icon.style.color = '#94a3b8';
                                                    }}
                                                    onMouseEnter={(e: React.MouseEvent<HTMLInputElement>) => {
                                                        if (document.activeElement !== e.currentTarget) {
                                                            e.currentTarget.style.borderColor = '#cbd5e1';
                                                            e.currentTarget.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.08)';
                                                        }
                                                    }}
                                                    onMouseLeave={(e: React.MouseEvent<HTMLInputElement>) => {
                                                        if (document.activeElement !== e.currentTarget) {
                                                            e.currentTarget.style.borderColor = '#e2e8f0';
                                                            e.currentTarget.style.boxShadow = '0 1px 3px rgba(0, 0, 0, 0.05)';
                                                        }
                                                    }}
                                                />
                                            </div>

                                            <div className="row mb-2 align-items-center py-2">
                                                <div className="col-6">
                                                    <strong>Location Name</strong>
                                                </div>
                                                <div className="col-3 text-center">
                                                    <strong>Assign</strong>
                                                </div>
                                                <div className="col-3 text-center">
                                                    <strong>Hide</strong>
                                                </div>
                                            </div>
                                            <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                                                {
                                                    locations?.state?.agentMappedLocationDetails
                                                        ?.filter((item: { name: string, id: string }) =>
                                                            item.name.toLowerCase().includes(locationSearchQuery.toLowerCase())
                                                        )
                                                        ?.map((item: { name: string, id: string }) => (
                                                            <ul className="list-group list-group-flush mt-1" key={item.id}>
                                                                <li className="list-group-item">
                                                                    <div className="row align-items-center py-2">
                                                                        <div className="col-6">
                                                                            {item.name}
                                                                        </div>
                                                                        <div className="col-3 text-center">
                                                                            <input type="checkbox" className="form-check-input" disabled={(locations.state?.primaryLocations || []).includes(item.name.trim())}
                                                                                name={item.id}
                                                                                checked={(locations.state?.primaryLocations || []).includes(item.name.trim()) || checkedLocs.includes(item.id)}
                                                                                // defaultChecked={locations.state.primaryLocations.includes(item.name.trim()) || checkedLocs.includes(item.id) || assignAllLocs}
                                                                                onChange={handleChange}
                                                                                style={{ margin: 0 }} />
                                                                        </div>
                                                                        <div className="col-3 text-center">
                                                                            <input type="checkbox" className="form-check-input"
                                                                                disabled={(locations.state?.primaryLocations || []).includes(item.name.trim())}
                                                                                name={item.id}
                                                                                checked={hiddenLocs.includes(item.id)}
                                                                                onChange={handleHideChange}
                                                                                style={{ margin: 0 }} />
                                                                        </div>
                                                                    </div>
                                                                </li>
                                                            </ul>
                                                        ))
                                                }
                                            </div>
                                            <div className="text-center mt-3 d-flex flex-wrap justify-content-center" style={{ gap: '8px' }}>
                                                <button className="btn btn-primary app-button-color btn-sm mb-2" onClick={(e: React.MouseEvent<HTMLElement>) => {
                                                    e.preventDefault(); /*setAssignAllLocs(true)*/ setCheckedLocs(getAllLocationIds)
                                                }}>Assign All</button>
                                                <button className="btn btn-secondary btn-sm mb-2" onClick={(e: React.MouseEvent<HTMLElement>) => { e.preventDefault(); setCheckedLocs([]) }}>Unassign All</button>
                                                <button className="btn btn-warning btn-sm mb-2" onClick={(e: React.MouseEvent<HTMLElement>) => { e.preventDefault(); setHiddenLocs(getAllLocationIds) }}>Hide All</button>
                                                <button className="btn btn-info btn-sm mb-2" onClick={(e: React.MouseEvent<HTMLElement>) => { e.preventDefault(); setHiddenLocs([]) }}>Unhide All</button>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div> : ""

                    }

                    <div className="text-center">
                        <button
                            type="submit"
                            className="btn btn-primary app-button-color mr-2"
                            disabled={disable}
                        >
                            {isLoading && (
                                <span className="spinner-border text-white mr-1" style={{ width: '18px', height: "18px" }} role="status"></span>
                            )}{" "}
                            {buttonname}
                        </button>
                        {
                            // locations.state && <button type="button" className={locations.state.is_active ? "btn btn-danger mr-2" : "btn btn-success mr-2"} onClick={(e) => { handleDelete(e, locations.state.id, locations.state?.names) }}> {locations.state.is_active ? "Deactivate" : "Activate"} </button>
                            locations.state && <button type="button" className={locations.state.is_active ? "btn btn-danger mr-2" : "btn btn-success mr-2"} onClick={(e) => { setShowPopUp(true) }}> {locations.state.is_active ? "Deactivate" : "Activate"} </button>
                        }
                        {disable ? (
                            <Link
                                to={constant.AGENT_LIST}
                                className="disabledCursor"
                                onClick={(event) => event.preventDefault()}
                            >
                                <button
                                    type="button"
                                    disabled={disable}
                                    className="btn btn-secondary"
                                >
                                    Cancel
                                </button>
                            </Link>
                        ) : (
                            <Link to={constant.AGENT_LIST}>
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                >
                                    Cancel
                                </button>
                            </Link>
                        )}
                    </div>
                </Form >
            </div >
        </>
    );
};

export default CreateAgent;
